export default __webpack_public_path__ + "static/media/credpal.188daebd.png";